import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16d0b7ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faces-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "faces-panel__header text-caption text-grey-6 q-px-sm q-pt-sm q-pb-xs" }, " Faces ", -1))
const _hoisted_3 = { class: "faces-panel__grid q-pa-sm" }
const _hoisted_4 = {
  key: 1,
  class: "text-caption text-grey-5 q-pa-sm text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_PersonFaceItem = _resolveComponent("PersonFaceItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_q_linear_progress, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faces, (face) => {
        return (_openBlock(), _createBlock(_component_PersonFaceItem, {
          key: face.id,
          face: face,
          "client-id": _ctx.clientId,
          selected: _ctx.selectedId === face.id,
          onSelect: ($event: any) => (_ctx.toggle(face.id)),
          onReassigned: ($event: any) => (_ctx.onRemoved(face.id)),
          onDeleted: ($event: any) => (_ctx.onRemoved(face.id))
        }, null, 8, ["face", "client-id", "selected", "onSelect", "onReassigned", "onDeleted"]))
      }), 128))
    ]),
    (!_ctx.isLoading && _ctx.faces.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No faces "))
      : _createCommentVNode("", true)
  ]))
}